import { Category } from "./category";
import { SystemField } from "./system-field";

export class ReportSaleByItem extends SystemField{
    product_id?:string;
    category_id?:string;
    total_qty?:number;
    total_amount?:number;
    total_discount?:number;
    unit_price?:number;
    sale_hour?:string;
    product_name?:string;
    category_name?:string;
    pricebook_name?:string;
    pricebook_id?:string;
    sub_amt?:number;
    uom_id?:string;
    sale_summary_id?:string;
    total_cost?:number;

    //relationship
    category?:Category;
}
